import EventBus from "./event-bus";

export function errorHandler(err) {
  if(err.response != undefined) {
    if(err.response.status == 403) {
      EventBus.$emit("sessionExpired");
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/common.js